import logo from './logo.png'

export const theme = {
    color: {
      primary: "#c9b9dc",
      primaryHover: "#b49ece",
    },
    logoImage: logo,
    backend: "https://elkb.epaper-publishing-one.de/",
    header: {
      customer: "",
      title: "Amt für Gemeindedienst + Gottesdienst-Institut",
    },
    directory: "/kiosk",
    info: [{
      text: 'Impressum',
      link: 'https://www.bayern-evangelisch.de/impressum.php'
    },
    {
    text: 'Datenschutz',
    link: 'https://www.bayern-evangelisch.de/datenschutz.php'
  }],
  };